import React, { useCallback } from 'react';
import { useLoadingThemeContext } from './ReportThemeContainer';
import { Logon as CrossOriginLogon } from '../../utils/authorization';
import { LoadingText } from './LoadingText';
export const Logon = (props) => {
    const [, style] = useLoadingThemeContext();
    const buttonTokens = useCallback(() => {
        const tokens = {};
        if (style === null || style === void 0 ? void 0 : style.primary) {
            tokens.bg = style.primary;
            tokens.bd = 'transparent';
        }
        if (style === null || style === void 0 ? void 0 : style.textColorInverse) {
            tokens.fg = style.textColorInverse;
        }
        return tokens;
    }, [style]);
    const css = {};
    if (style === null || style === void 0 ? void 0 : style.backgroundColor) {
        css.backgroundColor = style.backgroundColor;
    }
    if (style === null || style === void 0 ? void 0 : style.fontFamily) {
        css.fontFamily = style.fontFamily;
    }
    if (style === null || style === void 0 ? void 0 : style.textColor) {
        css.color = style.textColor;
    }
    return (React.createElement(CrossOriginLogon, { url: props.url, authenticationType: props.authenticationType, buttonTokens: buttonTokens, loadingFallback: () => React.createElement(LoadingText, null), style: css }));
};
